import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { signUp } from '../../features/authentication/AuthenticationSlice';
import Loading from '../../Loading';
import Broadcast from '../dashboard/Broadcast';
import Button from '../form/Button';

import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { host } from '../../function/api'
import $ from 'jquery'


function CreateAgent(props) {

    const navigate = useNavigate()
    const [mobile, setMobile] = useState('')
    const [password, setPassword] = useState('')
    const [city, setCity] = useState('')
    const [username, setUsername] = useState('')

    const [FlagStatus, setFlag] = useState(true)

    const account = {
        'name': username,
        'city': city,
        'flag': FlagStatus == true ? '1' : null,
        'mobile': mobile,
        'password': password
    }

    const dispatch = useDispatch()
    const user = useSelector(state => state.authentication.user)
    const loading = useSelector(state => state.authentication.loading)
    const error = useSelector(state => state.authentication.error)
    const errorCity = useSelector(state => state.authentication.errorCity)
    const errorName = useSelector(state => state.authentication.errorName)
    const mobileError = useSelector(state => state.authentication.mobileError)
    const errorFlag = useSelector(state => state.authentication.errorFlag)

    const passwordError = useSelector(state => state.authentication.passwordError)
    const redirectFlag = useSelector(state => state.authentication.redirectFlag)

    const registerHandler = async (event) => {
        event.preventDefault();

        const data = {
            'name': username,
            'city': city,
            'flag': FlagStatus,
            'mobile': mobile,
            'password': password
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}agent/create`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("نماینده جدید با موفقیت ایجاد شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })
                setMobile(' ')
                setPassword(' ')
                setCity(' ')
                setUsername(' ')

                setFlag(true)

            }


        } catch (error) {
            if (typeof (error.response) == 'object') {
                const listError = error.response.data.error;
                console.log(listError);

                $.each(listError, function (index, value) {
                    // error+index = value[0];
                    if (typeof (value) == 'object') {
                        toast.error(value[0], {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    } else {
                        toast.error(value, {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    }
                });
            }
        }
    }
    const goToUserIndex = () => {
        navigate('/dashboard/agents', { replace: true })
    }

    

    return (
        <>
            {loading ? (<Loading />) : null}
            <Broadcast title={'افزودن نماینده جدید'} />
            <form className="text-end  ">
                <div className='row rahpardaznet-cart my-5 print-position'>
                    <div className=" row col-12">
                        <div className="col-12 col-md-6">
                            <div className="m-3 rahpardaznet-form-controll">
                                <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                                    نام نماینده
                                </label>
                                <input
                                    tabIndex="1"
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="form-control shadow-none"
                                    id="staticName"
                                    autoFocus
                                />
                                {
                                    (errorName) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorName}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="m-3 rahpardaznet-form-controll">
                                <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                                    شهر
                                </label>
                                <input
                                    tabIndex="2"
                                    type="text"

                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    className="form-control shadow-none"
                                    id="staticName"
                                    autoFocus
                                />
                                {
                                    (errorCity) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorCity}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="m-3 rahpardaznet-form-controll">
                                <label forhtml="staticMobile" className="fw-bold text-end form-label px-1">
                                    موبایل
                                </label>
                                <input
                                    tabIndex="3"
                                    type='text'
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                    className="form-control shadow-none text-left ltr"
                                    id='exampleInputMobile'
                                    aria-describedby='mobileHelp'
                                />
                                {
                                    (mobileError) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger'>{mobileError}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="m-3 rahpardaznet-form-controll">
                                <label forhtml="staticPassword" className="fw-bold text-end form-label px-1">
                                    گذرواژه
                                </label>
                                <input
                                    tabIndex="4"
                                    type='text'
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="form-control  shadow-none"
                                    id='exampleInputPassword'
                                    aria-describedby='passwordHelp'
                                />
                                {
                                    (passwordError) ? (
                                        <span className="help-block  fw-bold d-inline-block mt-2 has-error">
                                            <small className='text-danger'>{passwordError}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>
                        <div className="col-12 p-4 d-flex flex-reverse">
                            <div className='form-check form-switch form-check-reverse'>

                                <input
                                    tabIndex='5'
                                    name='flag'
                                    type="checkbox"
                                    defaultChecked={FlagStatus}
                                    className="form-check-input"
                                    role="switch"
                                    onChange={(e) => setFlag(e.target.checked)}

                                />
                                {/* {
                                (FlagStatus) ? (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-success'>فعال</strong>
                                    </label>
                                ) : (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-danger'>غیرفعال</strong>
                                </label>
                                )
                            } */}


                                {
                                    (errorFlag) ? (
                                        <span className="help-block fw-bold d-inline-block mt-2">
                                            <small className='text-danger validate-error'>{errorFlag}</small>
                                        </span>
                                    ) : ''}
                            </div>
                        </div>


                    </div>
                </div>
            </form>
            <div className="row p-0">
                <div className='col-12 p-0'>
                    <Button
                        tab='6'
                        title='برگشت به صفحه نمایندگان'
                        design="rahpardaznet-button outline"
                        event={goToUserIndex}
                    />

                    <button
                        tabIndex="7"
                        onClick={registerHandler}
                        type="submit"
                        className="rahpardaznet-button">
                        {'  ثبت نام  '}
                        {
                            (loading) ? (
                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            ) : ''
                        }
                    </button>
                    {
                        (user) ? (
                            error
                        ) : ''
                    }
                </div>
            </div>

        </>

    )
}

export default CreateAgent;